// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fm-edit-type-dropdown td.field{min-width:10rem}", "",{"version":3,"sources":["webpack://./src/lib/components/edit-type/edit-type-dropdown.scss"],"names":[],"mappings":"AACC,gCACC,eAAA","sourcesContent":[".fm-edit-type-dropdown {\n\ttd.field {\n\t\tmin-width: 10rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
